import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Filter from "../components/datatable/Filter";
import Button from "../components/Button";

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    unassigned: {
        name:   'Unassigned',
        value:  'unassigned',
    },
    assigned_unscheduled: {
        name:   'Assigned Unscheduled',
        value:  'assigned_unscheduled',
    },
    assigned_scheduled: {
        name:   'Assigned Scheduled',
        value:  'assigned_scheduled',
    },
    completed: {
        name:   'Completed',
        value:  'completed',
    },
    actioned: {
        name:   'Actioned',
        value:  'actioned',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const OverviewSurveyDataTable = (props) => {
    const dataTableRef                      = useRef(null);
    const [search, setSearch]               = useState("");
    const [statusFilter, setStatusFilter]   = useState(FILTER_OPTIONS.all.value);
    const [jobTypeFilter, setJobTypeFilter] = useState(null);
    const [userFilter, setUserFilter]       = useState(null);

    const renderRowButton = (survey) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!survey.can && survey.can.view === true && survey.deleted_at === "-" && (
                        <a className="text-primary cursor-pointer" href={route('job.survey.show', {job: survey.job_id, survey: survey.id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    const renderNotes = (item) => {
        if (!item.notes || item.notes === "") {
            return "-";
        }

        return (
            <div className={"bespoke-tooltip"}>
                <div className={"tooltip-icon"}>
                    <i className="fa fa-sticky-note" />
                </div>
                <div className={"tooltip-text"}>
                    <span>{item.notes}</span>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Card classes={"border-0"} noPadding={true}>
                <div className="row">
                    <div className="col-12 col-xl-3 mb-3">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                    <Filter
                        label={"Status:"}
                        value={statusFilter}
                        options={Object.values(FILTER_OPTIONS)}
                        name={"filter_status"}
                        onChange={(value) => setStatusFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"Job Type:"}
                        value={jobTypeFilter}
                        options={props.jobTypes}
                        name={"filter_job_type"}
                        onChange={(value) => setJobTypeFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"User:"}
                        value={userFilter}
                        options={props.users}
                        name={"filter_user"}
                        onChange={(value) => setUserFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <div className="col-1"></div>
                    {can('create', 'job') && (
                        <div className="col-2 col-xs-4 float-right mb-3">
                            <Button
                                href={route('job.create', {origin: "overview-survey"}).toString()}
                                label={"Create Job"}
                                icon={"far fa-plus-circle"}
                                classes={"btn btn-eh-lilac px-3 justify-content-center"}
                            />
                        </div>
                    )}
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.overview.survey.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="surveys" />}
                                fieldsToExclude={statusFilter === FILTER_OPTIONS.archived.value ? [
                                    'id',
                                    'can',
                                ] : [
                                    'id',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    'job_id',
                                    'job_name',
                                    'job_type',
                                    'customer_name',
                                    'created_at',
                                    'user_name',
                                    'status',
                                ]}
                                fieldMap={{
                                    job_id:         "Job Ref",
                                    job_name:       "Job Name",
                                    job_type:       "Type",
                                    customer_name:  "Customer",
                                    user_name:      "User",
                                    created_at:     "Date Created",
                                    deleted_at:     "Date Archived",
                                    completed_at:   "Date Completed",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField="created_at"
                                defaultOrderByDirection="desc"
                                params={{
                                    searchTerm:    search,
                                    statusFilter:  statusFilter,
                                    jobTypeFilter: jobTypeFilter,
                                    userFilter:    userFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'notes':
                                            return renderNotes(row);
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default OverviewSurveyDataTable;

const target = document.getElementById('overview-survey-datatable');
if (target) {
    ReactDOM.render(
        <OverviewSurveyDataTable
            jobTypes={JSON.parse(target.dataset.jobTypes)}
            users={JSON.parse(target.dataset.users)}
        />,
        target
    );
}
